"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLinkedin32 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 32, height: 32, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M0 .5h32v32H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M24.45 6.75H7.55a1.3 1.3 0 0 0-1.3 1.3v16.9a1.3 1.3 0 0 0 1.3 1.3h16.9a1.3 1.3 0 0 0 1.3-1.3V8.05a1.3 1.3 0 0 0-1.3-1.3zM12.027 23.386H9.093v-9.323h2.934v9.323zM10.56 12.783a1.706 1.706 0 1 1 .01-3.413 1.706 1.706 0 0 1-.01 3.413zm12.344 10.603H20.03v-4.51c0-1.096 0-2.437-1.528-2.437-1.527 0-1.711 1.158-1.711 2.376v4.632H13.92v-9.384h2.688v1.28h.061a3.055 3.055 0 0 1 2.75-1.524c2.934 0 3.484 1.95 3.484 4.448v5.12z", fill: "currentColor" })] })) }))); };
exports.default = SvgLinkedin32;
